import {Pipe, PipeTransform} from '@angular/core';
import analyze from 'rgbaster';

@Pipe({
  name: 'getPredominantImageColor'
})
export class GetPredominantImageColorPipe implements PipeTransform {

  async transform(value: string): Promise<string> {
    if (value) {
      try {
        const result = await analyze(value);
        if (result && Array.isArray(result) && result.length > 0) {
          return result[0]?.color;
        }
      } catch (e) {
        return;
      }
    }
    return;
  }
}
